import * as React from "react";
import { TableFooter, TableRow, TableCell } from "@material-ui/core";

import { IUserTableProps } from "../UserTable";
import { Pagination } from "../../../components/Pagination";

export const UserTableFooter: React.FunctionComponent<IUserTableProps> = ({
  onChangePage,
  pagination,
  totalItems
}) => (
  <TableFooter>
    {onChangePage && (
      <TableRow>
        {pagination && (
          <TableCell>
            <Pagination
              totalItems={totalItems || 0}
              pagination={pagination}
              onChangePage={onChangePage}
            />
          </TableCell>
        )}
      </TableRow>
    )}
  </TableFooter>
);
